

const TRANSLATIONS_DA_DK = {
    "email_otp.back":"Tilbage",
    "email_otp.enter_email_text":"Angiv din adresse nedenfor, så sender vi en unik kode til dig",
    "email_otp.send_verification_link":"Send engangskode",
    "email_otp.resend_otp_with_timer":"Send engangskode igen om",
    "email_otp.text":"Vi har sendt en 6-cifret engangskode til [email]. Angiv koden nedenfor",
    "email_otp.verify":"Bekræft",
    "reset_password.set_password":"Nulstil adgangskode",
    "sign_in.or":"eller",
    "sign_in.continue_with":"Eller fortsæt med",
    "sign_in.continue_with_email":"Eller fortsæt med din e-mailadresse",
    "sign_in.create_without_password":"Opret en konto uden adgangskode",
    "sign_in.create_with_otp":"Opret en konto med engangskode",
    "sign_in.login_with_otp":"Log ind med engangskode",
    "sign_in.login_without_password":"Log ind uden adgangskode",
    "sign_in.tooltip_text":"Du får en mail med en engangskode, så du kan få adgang til din konto.",
    "sign_up.tooltip_text":"Du får en mail med en engangskode, så du kan oprette en konto.",
    "sign_in.password_updated":"Din adgangskode er blevet opdateret.",
    "sign_up.create_an_account":"Opret en konto",
    "email_otp.resend_otp":"Send OTP igen",
    "sign_up.email_address":"Emailadresse",
    "sign_up.password":"Password",
    "sign_in.create_account" : "Opret en konto",
    "sign_in.title": "Log Ind",
    "sign_in.forgot_password" : "Glemt dit password?",
    "reset_password.resend_email": "Send e-mail igen",
    "reset_password.sent_title": "En e-mail er sendt.",
    "reset_password.rcvResetLink": "Indtast din email adresse nedenfor og vi vil sende dig et link, så du kan nulstille til kodeord.",
    "reset_password.submit": "Indtast",
    "reset_password.back_to_login": "Tilbage til login",
    "reset_password.create_new_password": "Opret et nyt password og log ind på din konto.",
    "forgot_password.emailSent": "Hvis der allerede findes en konto for [], bliver der sendt en e-mail med et link til nulstilling af adgangskoden. Har du ikke fået den endnu? Bed om en ny e-mail herunder.",
    "gdpr.continue": "Fortsæt",
    "validation.password_validation_heading": "Adgangskoden skal indeholde:",
    "validation.password_length_ui": "Mindst 8 tegn",
    "validation.password_upper_case_ui": "Et stort bogstav",
    "validation.password_lower_case_ui": "Et lille bogstav",
    "validation.password_number_ui": "Et tal",
    "validation.password_symbol_ui": "Et specialtegn",
    "verify_otp.customer_service_center_link": "s/kontakt-os",
    "activate_user.verification_successful.message": "Sådan! Din konto er nu aktiveret.",
    "activate_user.already_verified.message" : "Velkommen tilbage! Din konto er allerede blevet verificeret.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Udfyld alle de obligatoriske felter, før du fortsætter.",
    "sign_in.invalid_email_error": "Angiv en gyldig mailadresse såsom navn@domæne.com",
    "sign_in.invalid_credentials_error": "Du har indtastet et ugyldigt brugernavn eller adgangskode. Prøv igen.",
    "sign_in.generic_error": "Noget gik galt. Prøv igen.",
    "sign_in.account_unverified_error": "Din konto er ikke aktiveret endnu. Tjek din mail for at finde aktiveringslinket, eller klik på 'Glemt adgangskode?' for at nulstille adgangen til din konto.",
    "sign_in.max_attempt_error": "Du har ikke flere forsøg. Prøv igen om noget tid.",
    "sign_in.social_signin_error": "Fælleslogin (Google/Facebook/Apple) mislykkedes. Prøv igen, eller brug en anden loginmetode",
    "sign_in.social_signin_email_not_present_error": "Login mislykkedes. Prøv igen, eller brug en anden loginmulighed.",
    "sign_in.guest_user_signin_error": "Det ser ud til, at du allerede har en konto med denne e-mailadresse. Klik på ”Glemt adgangskode?” for at nulstille adgangen til kontoen.",

    "sign_up.mandatory_field_error": "Udfyld alle de obligatoriske felter, før du fortsætter.",
    "sign_up.invalid_email_error": "Angiv en gyldig mailadresse, f.eks. navn@domæne.com",
    "sign_up.password_length_error": "Adgangskoden skal være på mindst 8 tegn.",
    "sign_up.email_already_exist_error": "Denne e-mailadresse findes allerede. Brug en anden e-mailadresse.",
    "sign_up.generic_error": "Noget gik galt. Prøv igen.",
    "sign_up.password_policy_error": "Adgangskoden skal indeholde: et tal, et specialtegn [!#$%&'*+-/=?^_`{|}~.@], stort bogstav og lille bogstav.",
    "sign_up.common_password_error": "Du må ikke bruge din e-mailadresse som adgangskode",

    "forgot_password.mandatory_field_error": "Udfyld alle de obligatoriske felter, før du fortsætter.",
    "forgot_password.invalid_email_error": "Angiv en gyldig mailadresse såsom navn@domæne.com",
    "forgot_password.generic_error": "Noget gik galt. Prøv igen.",

    "reset_password.mandatory_field_error": "Udfyld alle de obligatoriske felter, før du fortsætter.",
    "reset_password.password_history_error": "Den må ikke ligne dine seneste fem adgangskoder.",
    "reset_password.password_length_error": "Adgangskoden skal være på mindst 8 tegn.",
    "reset_password.password_policy_error": "Adgangskoden skal indeholde: et tal, et specialtegn [!#$%&'*+-/=?^_`{|}~.@], stort bogstav og lille bogstav.",
    "reset_password.common_password_error": "Du må ikke bruge din e-mailadresse som adgangskode",
    "reset_password.generic_error": "Noget gik galt. Prøv igen.",

    "email_otp.email_required_error": "Angiv din mailadresse for at fortsætte",
    "email_otp.invalid_email_error": "Angiv en gyldig mailadresse, f.eks. navn@domæne.com",
    "email_otp.generic_error": "Noget gik galt. Prøv igen om noget tid",
    "email_otp.invalid_otp_error": "Den OTP-/verificeringskode, du har angivet, er ikke gyldig. Prøv igen.",
    "email_otp.resend_otp_error": "OTP blev ikke sendt igen. Prøv igen om noget tid",
    "email_otp.verify_otp_error": "Noget gik galt. Prøv at bruge OTP-verificering efter noget tid",
    "email_otp.verify_otp_limit_exceed_error": "Den angivne OTP er ugyldig. Klik på 'Send OTP igen' for at modtage en ny kode",
    "email_otp.max_attempt_reached_error": "Du har ikke flere forsøg. Prøv igen om noget tid.",
    "email_otp.brute_force_error_part_1": "Din konto er midlertidigt spærret på grund af flere mislykkede loginforsøg. Prøv igen, eller ",
    "email_otp.brute_force_error_part_2": "kontakt supporten",
    "email_otp.brute_force_error_part_3": " for at få hjælp.",
    "form.gdprconsent": "Ved at logge ind erklærer du, at du har læst og accepterer vores",
    "form.termsCondition": "vilkår og betingelser",

    //Page Titles
    "sign_in.page_title": "Log ind | Pens.com",
    "sign_up.page_title": "Registrer Dig | Pens.com",
    "forgot-password.page_title": "Glemt Password | Pens.com",
    "reset-password.page_title": "Gendan Password | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_DA_DK;